import script from "D:\\Games\\van\\van3\\v3\\ui\\explainer\\Chip.vue?type=script"
export * from "D:\\Games\\van\\van3\\v3\\ui\\explainer\\Chip.vue?type=script"

import "D:\\Games\\van\\van3\\v3\\ui\\explainer\\Chip.vue?type=style&index=0"
export default script
script.__scopeId = "data-v-85ef45aa"